<template>
  <label :class="[$style['form-input'], {[$style['form-input--error']]: meta.touched && !meta.valid }]">
    <div :class="$style['form-input__label']">
      {{ label }}
    </div>
    <textarea v-model="value" v-bind="$attrs" :class="$style['form-input__input']" />
    <div v-if="errors.length" :class="$style['form-input__errors']">
      {{ errors[0] }}
    </div>
  </label>
</template>
<script setup lang="ts">
import { useField } from 'vee-validate'
const props = defineProps<{
  name: string
  modelValue?: string
  label?: string
}>()

const { value, errors, meta } = useField(() => props.name, undefined, { syncVModel: true })
</script>
<style  module>
.form-input {
  width: 100%;
}

.form-input__label {
  font-size: var(--font-size);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-s);
}

.form-input__input {
  background-color: transparent;
  border-radius: var(--border-radius);
  color: var(--text-base);
  border: 1px solid var(--border-subtle);
  padding: var(--spacing-m) var(--spacing-l);
  font-size: var(--font-size);
  outline: none;
  resize: none;
  width: 100%;
}

.form-input__input:focus {
  border-color: var(--color-primary);
}

.form-input__errors {
  color: var(--primary-color-50);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  padding: var(--spacing) 0;
}

.form-input--error .form-input__input {
  border-bottom-color: var(--primary-color-50);
}

</style>
